<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="my-3">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
          ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="3" v-if="this.$route.name === 'viewDataFate'">
                <el-text-field
                  label="OBJ_ID_TEIKEJO"
                  v-model="mainData['obj_id_teikejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3" v-if="this.$route.name === 'viewDataFate'">
                <el-text-field
                  label="OBJ_KODAS_TEIKEJO"
                  v-model="mainData['obj_kodas_teikejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3" v-if="this.$route.name === 'viewDataFft'">
                <el-text-field
                  label="FIZ_KODAS_TEIKEJO"
                  v-model="mainData['fiz_kodas_teikejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="AMN_ID_TEIKEJO"
                  v-model="mainData['amn_id_teikejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="FIZ_KODAS_GAVEJO"
                  v-model="mainData['fiz_kodas_gavejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="OBJ_ID_GAVEJO"
                  v-model="mainData['obj_id_gavejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="OBJ_KODAS_GAVEJO"
                  v-model="mainData['obj_kodas_gavejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="AMN_ID_GAVEJO"
                  v-model="mainData['amn_id_gavejo-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="FAVA_ID"
                  v-model="mainData['fava_id-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="FAVA_PAVAD"
                  v-model="mainData['fava_pavad-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3" v-if="this.$route.name === 'viewDataFft'">
                <el-text-field
                  label="FFT_ID"
                  v-model="mainData['fft_id-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3" v-if="this.$route.name === 'viewDataFft'">
                <el-text-field
                  label="FFT_PAVAD"
                  v-model="mainData['fft_pavad-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3" v-if="this.$route.name === 'viewDataFate'">
                <el-text-field
                  label="FATE_ID"
                  v-model="mainData['fate_id-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3" v-if="this.$route.name === 'viewDataFate'">
                <el-text-field
                  label="FATE_PAVAD"
                  v-model="mainData['fate_pavad-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="IGA_ID"
                  v-model="mainData['iga_id-search-like']"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ViewDataSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
    getSearchParamKey() {
      return this.$route.name
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getSearchParams()
    this.searchData()
  },
  methods: {
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      if (
        this.searchParams &&
        this.searchParams.route === this.getSearchParamKey
      ) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData() {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.getSearchParamKey,
        mainData: this.mainData,
      })
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = { isExpanded: true, clear: true }
      this.errors.clear()
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData()
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData()
        }
      })
    },
  },
}
</script>
